import React from "react"
import { Navigate } from "react-router-dom"

// Profile
import UserProfile from "../pages/Authentication/user-profile"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import ForgetPwd from "../pages/Authentication/ForgetPassword"
import ConfigUrl from "../config"

// Dashboard
import Dashboard from "../pages/Dashboard/index"
import Portfolio from "pages/Portfolio"
import AddPortfolio from "pages/Portfolio/AddPortfolio"
import EditPortfolio from "pages/Portfolio/EditPortfolio"
import Tips from "pages/Tips/Index"
import AddTip from "pages/Tips/AddTip"
import EditTip from "pages/Tips/EditTip"
import Roles from "pages/Roles"
import UserIndex from "pages/Users/index"
import AddUser from "pages/Users/adduser"
import EditUser from "pages/Users/edituser"
import { components } from "react-select"
import AddRole from "pages/Roles/AddRole"
import EditRole from "pages/Roles/EditRole"
import AuditLogs from "pages/AuditLog"
import Contact from "pages/Contact"
import MarketNews from "pages/MarketNews"
import LoginOtp from "pages/Authentication/Otp"
import CustomerIndex from "pages/Customers"
import AddCustomer from "pages/Customers/add-customer"
import EditCustomer from "pages/Customers/edit-customer"
import ResetPassword from "pages/Authentication/ResetPassword"
import Testimonials from "pages/Testimonials"
import MetaContent from "pages/MetaTitle"
import AddTestimonial from "pages/Testimonials/Addtestimonial"
import EditTestimonial from "pages/Testimonials/EditTestimonial"
import Payout from "pages/Payout"
import Addpayout from "pages/Payout/addpayout"
import EditPayout from "pages/Payout/editpayout"
import CustomerQuery from "pages/CustomerQuery"
import DailyTrades from "pages/Daily-Trades"
import StockPurchase from "pages/StockPurchase"
import TradingData from "pages/TradingData"

const authProtectedRoutes = [
  
  { path: `${ConfigUrl.appurl}dashboard`, component: <Dashboard/> },

  // //profile
  { path: `${ConfigUrl.appurl}profile`, component: <UserProfile/> },

  { path : `${ConfigUrl.appurl}portfolio` , component : <Portfolio/>},
  { path : `${ConfigUrl.appurl}add-portfolio` , component : <AddPortfolio/>},
  { path : `${ConfigUrl.appurl}edit-portfolio/:slug` , component : <EditPortfolio/>},
  { path : `${ConfigUrl.appurl}tips`, component: <Tips /> },
  { path : `${ConfigUrl.appurl}add-tip` , component : <AddTip/>},
  { path : `${ConfigUrl.appurl}edit-tip/:slug` , component : <EditTip/>},
  { path : `${ConfigUrl.appurl}roles`, component: <Roles /> },
  { path : `${ConfigUrl.appurl}users` , component : <UserIndex/>},
  { path : `${ConfigUrl.appurl}add-user` , component : <AddUser/>},
  { path : `${ConfigUrl.appurl}edit-user/:slug` , component : <EditUser/>},
  { path : `${ConfigUrl.appurl}customers` , component : <CustomerIndex/>},
  { path : `${ConfigUrl.appurl}add-customer` , component : <AddCustomer/>},
  { path : `${ConfigUrl.appurl}edit-customer/:slug` , component : <EditCustomer/>},
  { path : `${ConfigUrl.appurl}add-role` , component : <AddRole/>},
  { path : `${ConfigUrl.appurl}edit-role/:slug` , component : <EditRole/>},
  { path : `${ConfigUrl.appurl}audit-logs` , component : <AuditLogs/> },
  { path : `${ConfigUrl.appurl}contact-enquiry` , component : <Contact/>},
  { path : `${ConfigUrl.appurl}market` , component : <MarketNews/>},
  { path : `${ConfigUrl.appurl}testimonials` , component : <Testimonials/>},
  { path : `${ConfigUrl.appurl}add-testimonial` , component : <AddTestimonial/>},
  { path : `${ConfigUrl.appurl}edit-testimonial/:slug` , component : <EditTestimonial/>},
  { path : `${ConfigUrl.appurl}meta-content` , component : <MetaContent/>},
  { path : `${ConfigUrl.appurl}payouts` , component : <Payout/>},
  { path : `${ConfigUrl.appurl}add-payout` , component : <Addpayout/>},
  { path : `${ConfigUrl.appurl}edit-payout/:slug` , component : <EditPayout/>},
  { path : `${ConfigUrl.appurl}customer-query` , component : <CustomerQuery/>},
  { path : `${ConfigUrl.appurl}daily-trades` , component : <DailyTrades/>},
  { path : `${ConfigUrl.appurl}stock-purchase` , component : <StockPurchase/>},
   { path : `${ConfigUrl.appurl}trading` , component : <TradingData/>},
  

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
   {
    path: `${ConfigUrl.appurl}`,
    exact: true,
    component: < Navigate to={`${ConfigUrl.appurl}dashboard`} />,
  },
]

const publicRoutes = [
  { path: `${ConfigUrl.appurl}login`, component: <Login /> },
  { path: `${ConfigUrl.appurl}forgot-password`, component: <ForgetPwd /> },
  { path: `${ConfigUrl.appurl}verify-otp` , component : <LoginOtp/>},
  { path: `${ConfigUrl.appurl}reset-password` , component : <ResetPassword/>}
]

export { authProtectedRoutes, publicRoutes }

